import { useRouter } from 'next/router'
import { makeStaticProps } from '@/utils/getStatic'
import { useRedirect } from '@/utils/redirect'

// Redirect for /articles (not /en/articles) urls
const ArticlesPage = () => {
  useRouter()
  useRedirect(`/articles`)
}

export default ArticlesPage
const getStaticProps = makeStaticProps(['common', 'articles-listing'])

export { getStaticProps }
